import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBuilding } from '@fortawesome/free-solid-svg-icons'
import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'

library.add(faBuilding)
library.add(fas)
library.add(fab)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false

axios.defaults.baseURL = process.env.VUE_APP_API_URL || "http://127.0.0.1:8000"

// ── Enregistrement immédiat du service worker ──────────────────
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js', { scope: '/' })
    .then(reg => console.log('✅ Service Worker enregistré au démarrage (Manager)'))
    .catch(err => console.warn('⚠️ Service Worker échec:', err));
}

var filter = function (text, length, clamp) {
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
}
Vue.filter('truncate', filter);

// ══════════════════════════════════════════════════════════════════
//  WEBPUSH NATIF VAPID (Manager)
// ══════════════════════════════════════════════════════════════════
const VAPID_PUBLIC_KEY = process.env.VUE_APP_VAPID_PUBLIC_KEY

function urlBase64ToUint8Array(b64) {
  const pad = '='.repeat((4 - b64.length % 4) % 4)
  const raw = atob((b64 + pad).replace(/-/g, '+').replace(/_/g, '/'))
  return Uint8Array.from([...raw].map(c => c.charCodeAt(0)))
}

function getCsrfToken() {
  return document.cookie.split(';')
    .map(c => c.trim()).find(c => c.startsWith('csrftoken='))
    ?.split('=')[1] ?? ''
}

function detectBrowser() {
  const ua = navigator.userAgent
  if (ua.includes('Firefox'))  return 'firefox'
  if (ua.includes('Opera'))    return 'opera'
  return 'chrome'
}

async function proceedToSubscription(vueRouterInstance) {
  try {
    const reg = await navigator.serviceWorker.ready;
    await navigator.serviceWorker.ready;

    navigator.serviceWorker.addEventListener('message', (event) => {
      const { type, url } = event.data || {}
      if (type === 'JOUER_SON') jouerSon()
      if (type === 'NOTIFICATION_CLICK' && url && vueRouterInstance) {
        vueRouterInstance.push(url).catch(() => { window.location.href = url })
      }
    })

    let sub = await reg.pushManager.getSubscription()
    if (sub) await sub.unsubscribe()

    sub = await reg.pushManager.subscribe({
      userVisibleOnly:      true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    })

    const token = store.state.token || localStorage.getItem('token') || ''
    await axios.post('/api/v1/webpush/subscribe/', {
      status_type:  'subscribe',
      subscription: sub.toJSON(),
      group:        'managers',
      browser:      detectBrowser(),
    }, {
      headers: {
        'Content-Type':  'application/json',
        'Authorization': token ? `Token ${token}` : '',
        'X-CSRFToken':   getCsrfToken(),
      }
    })
    console.log('🚀 [WebPush] Souscription envoyée à Django avec succès (Manager)')
    return true;
  } catch (e) {
    console.error('❌ Erreur de souscription :', e)
    return false;
  }
}

// Fonction utilisée par la bannière et par l'interface
window._triggerWebPushPermission = async (vueRouterInstance) => {
  if (Notification.permission === 'denied') {
    console.warn("⚠️ Notifications bloquées (Cadenas).");
    return false;
  }
  if (Notification.permission !== 'granted') {
    const perm = await Notification.requestPermission();
    if (perm !== 'granted') return false;
  }
  return proceedToSubscription(vueRouterInstance);
}

function jouerSon() {
  try {
    const ctx  = new (window.AudioContext || window.webkitAudioContext)()
    const osc  = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.connect(gain); gain.connect(ctx.destination)
    osc.frequency.value = 520; osc.type = 'triangle'
    gain.gain.setValueAtTime(0.6, ctx.currentTime)
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.4)
    osc.start(); osc.stop(ctx.currentTime + 0.45)
  } catch (e) {
    console.warn('Erreur audio:', e)
  }
}

const app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
